import {
  updateAsyncActivityHelperHack,
  updateRenderHelperHack,
  handleAdd,
  createTask,
  isGrouped
} from '../../../GanttVisualization.helper';

import { trackingEvent } from '../../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../../analytics/utils';
import { convertPPTask2PluginTask } from '../../../../../views/lookahead/planification/index.helper';
import { store } from '../../../../../redux/store';

async function createTaskFromActivity(activityId) {
  try {
    if (!activityId || activityId === null) return;
    const thisTask = window.ganttVisualization.getTask(activityId);
    const thisActivityReferenceLvl = window.activities.find(
      (act) => act.unique_id == thisTask.id
    );
    const state = store.getState();
    const projectState = state.projectState;

    const toAdd = await handleAdd(
      thisActivityReferenceLvl,
      projectState,
      updateAsyncActivityHelperHack,
      updateRenderHelperHack,
      window.ganttVisualization
    );

    trackingEvent(
      'lookahead_task_creation',
      {
        ...getBasicAmplitudEventProperties(),
        task_id: toAdd.id,
        parent_activity_name: thisActivityReferenceLvl?.name,
        parent_activity_id: thisActivityReferenceLvl?.id,
        event_source: 'task_add'
      },
      AMPLITUDE_SERVICE
    );

    const adaptedTask = convertPPTask2PluginTask(toAdd, null, thisTask);
    delete adaptedTask.parent;
    window.ganttVisualization.createTask(adaptedTask, activityId);
    window.ganttVisualization.refreshVisualizations &&
      window.ganttVisualization.refreshVisualizations(adaptedTask);
  } catch (error) {
    console.log('errorDelegation', error);
    thisTask.is_parent = false;
  }
}

async function duplicateActivity(activityId) {
  const showDuplicate =
    !window.ganttVisualization.hasChild(activityId) && !isGrouped();
  if (!showDuplicate || !activityId || activityId === null) return;
  const gantt = window.ganttVisualization;
  const thisTask = gantt.getTask(activityId);

  const thisActivityReferenceLvl = window.activities.find(
    (act) => act.unique_id == thisTask.id
  );
  console.log('thisTask', thisActivityReferenceLvl);
  const state = store.getState();
  const projectState = state.projectState;

  const toAdd = await createTask(
    null,
    'New task',
    thisActivityReferenceLvl,
    true,
    projectState,
    updateAsyncActivityHelperHack,
    updateRenderHelperHack,
    gantt
  );

  trackingEvent(
    'lookahead_task_creation',
    {
      ...getBasicAmplitudEventProperties(),
      task_id: toAdd.id,
      parent_activity_name: thisActivityReferenceLvl?.name,
      parent_activity_id: thisActivityReferenceLvl?.id,
      event_source: 'duplicate_activity'
    },
    AMPLITUDE_SERVICE
  );

  const adaptedTask = convertPPTask2PluginTask(toAdd, null, thisTask);
  delete adaptedTask.parent;
  window.ganttVisualization.createTask(adaptedTask, activityId);

  window.ganttVisualization.refreshVisualizations &&
    window.ganttVisualization.refreshVisualizations(adaptedTask);
  window.ganttVisualization.refreshView();
}

export default {
  createTaskFromActivity,
  duplicateActivity
};
